import { __rest, __assign } from './../../vendor/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Container.module.css.js';

var Container = function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'div' : _b, children = _a.children, className = _a.className, tokens = _a.tokens, containerProps = __rest(_a, ["as", "children", "className", "tokens"]);
    var Element = as;
    return (React__default.createElement(Element, __assign({ className: classNames(styles.root, className), style: __assign({}, tokens) }, containerProps), children));
};

export { Container };
//# sourceMappingURL=Container.js.map
